// components/details/Details.tsx
import classes from './Details.module.sass'
import { CatUploadInterface } from '../../../../../common/types/interfaces'
import { format } from 'date-fns'
import { CatUploadStatus } from '../../../../../common/types/enums'

type Props = {
  el?: CatUploadInterface
}

const getStatusText = (status: CatUploadStatus): string => {
  const map: Record<string, string> = {
    [CatUploadStatus.PENDING]: 'Ожидает',
    [CatUploadStatus.PROCESSING]: 'В обработке',
    [CatUploadStatus.SUCCESS]: 'Успешно',
    [CatUploadStatus.ERROR]: 'Ошибка',
  }
  return map[status] || 'Неизвестно'
}

const getStatusColor = (status: CatUploadStatus): string => {
  const map: Record<string, string> = {
    [CatUploadStatus.PENDING]: '#f39c12',
    [CatUploadStatus.PROCESSING]: '#3498db',
    [CatUploadStatus.SUCCESS]: '#2ecc71',
    [CatUploadStatus.ERROR]: '#e74c3c',
  }
  return map[status] || '#95a5a6'
}

export const Details = ({ el }: Props) => {
  if (el)
    return (
      <div className={classes.container}>
        <div className={classes.content}>
          <div className={classes.title}>информация об импорте</div>
          <div className={classes.row}>
            <div className={classes.id}>
              <div className={classes.label}>id</div>
              <div className={classes.value}>{el.id}</div>
            </div>
            <div className={classes.item}>
              <div className={classes.label}>Файл</div>
              <div className={classes.value}>{el.fileName}</div>
            </div>
          </div>

          <div className={classes.row}>
            <div className={classes.item}>
              <div className={classes.label}>Статус</div>
              <div className={classes.value} style={{ color: getStatusColor(el.status) }}>
                {getStatusText(el.status)}
              </div>
            </div>
            <div className={classes.item}>
              <div className={classes.label}>Cluster ID</div>
              <div className={classes.value}>{el.clusterId}</div>
            </div>
          </div>

          {el.importedAt && (
            <div className={classes.item}>
              <div className={classes.label}>Импортирован</div>
              <div className={classes.value}>
                {format(new Date(el.importedAt), 'dd.MM.yyy HH:mm')}
              </div>
            </div>
          )}

          <div className={classes.title}>статистика</div>
          <div className={classes.row}>
            <div className={classes.item}>
              <div className={classes.label}>Категорий</div>
              <div className={classes.value}>{el.categoriesImported || 0}</div>
            </div>
            <div className={classes.item}>
              <div className={classes.label}>Товаров</div>
              <div className={classes.value}>{el.itemsImported || 0}</div>
            </div>
            <div className={classes.item}>
              <div className={classes.label}>Картинок</div>
              <div className={classes.value}>{el.imagesImported || 0}</div>
            </div>
          </div>

          {el.errorMessage && (
            <>
              <div className={classes.title}>ошибка</div>
              <div className={classes.item}>
                <div className={classes.label}>Текст ошибки</div>
                <div className={classes.value} style={{ color: '#e74c3c' }}>
                  {el.errorMessage}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    )
}
